import { connect } from 'react-redux';
import DataSiswa from '../../../views/Student/DataSiswa/DataSiswa.student.view';
import { getStudent } from '../../../states/thunks/student.thunk';


function mapDispatchToProps(dispatch) {
  return {
    handleGetStudent: () => dispatch(getStudent()),
  };
}

export default connect(null, mapDispatchToProps)(DataSiswa);
